/* @flow */

import { createSelector } from '@reduxjs/toolkit';
import { hydrateMembership } from '@e180/domain/lib/membership/util';

const getMembershipId = (state) => state.app.membership;
const getEntities = (state) => state.domain.entities;

import type { Membership } from '@e180/domain/lib/membership/type';
import type { State } from 'src/shared/core/type/reduxTypes';

export const getMembership: (state: State) => ?Membership = createSelector(
  [getMembershipId, getEntities],
  (id, entities) => {
    if (id) {
      return hydrateMembership(id, entities);
    }
  },
);
